// Selector de especialidad SOLO para demos comerciales (pedido explícito
// del usuario 2026-09-01) — deja elegir, desde una lista desplegable fija en
// la esquina superior derecha, qué especialidad "ve" la cuenta de demo, para
// mostrar rápido cómo el catálogo especialidad→formularios filtra el
// sidebar/gate sin tener que dar de alta un PractitionerRole real por cada
// especialidad. Nunca escribe en Medplum — ver especialidadDemoOverride.ts.
// Invisible para cualquier cuenta que no sea la de demo (EMAIL_CUENTA_DEMO_ESPECIALIDAD).
import type { JSX } from 'react';
import { useMedplumProfile } from '@medplum/react-hooks';
import { useSyncExternalStore } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CATALOGO_ESPECIALIDADES_ORDENADO } from '@/lib/catalogoEspecialidades';
import { EMAIL_CUENTA_DEMO_ESPECIALIDAD } from '@/lib/useEspecialidadDelPracticante';
import { getEspecialidadDemoOverride, setEspecialidadDemoOverride, subscribeEspecialidadDemoOverride } from '@/lib/especialidadDemoOverride';

const SIN_OVERRIDE = '__real__';

export function SelectorEspecialidadDemo(): JSX.Element | null {
  const profile = useMedplumProfile();
  const override = useSyncExternalStore(subscribeEspecialidadDemoOverride, getEspecialidadDemoOverride, () => null);

  const esCuentaDemo = profile?.telecom?.some((t) => t.system === 'email' && t.value === EMAIL_CUENTA_DEMO_ESPECIALIDAD) ?? false;
  if (!esCuentaDemo) return null;

  return (
    <div className="fixed bottom-2 right-2 z-50 flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-2 py-1.5 shadow-sm">
      <span className="font-mono text-[10px] uppercase tracking-wide text-amber-700">Demo · especialidad</span>
      <Select value={override ?? SIN_OVERRIDE} onValueChange={(v) => setEspecialidadDemoOverride(v === SIN_OVERRIDE ? null : v)}>
        <SelectTrigger className="h-7 w-[220px] bg-white text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={SIN_OVERRIDE}>Especialidad real de la cuenta</SelectItem>
          {CATALOGO_ESPECIALIDADES_ORDENADO.map((e) => (
            <SelectItem key={e.codigo} value={e.codigo}>
              {e.nombre}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
